import { render, staticRenderFns } from "./ExternalLinkSearch.vue?vue&type=template&id=3229a704&scoped=true&"
import script from "./ExternalLinkSearch.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLinkSearch.vue?vue&type=style&index=0&id=3229a704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229a704",
  null
  
)

export default component.exports